import React, { useState } from "react";
import useDraftProjects from "../../../../hooks/allProjects/useDraftProjects";
import "./datatable.scss";
import Loader from "../../../../hooks/loader.js";

const Draftprojectstables = ({ setRoutes, search, boolSearch, tabKey }) => {
  const [copied, setCopied] = useState(false);
  const { projects, isLoading, error, pagination, handlePageChange } =
    useDraftProjects(search, boolSearch, tabKey);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const formatTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleCopy = (address) => {
    if (!address) return;
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  const copyAddress = (address) => {
    if (!address) return;
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (isLoading) {
    return (
      <section className="projectstable">
        <div className="loading">
          <Loader />
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="projectstable">
        <div className="error">Error: {error}</div>
      </section>
    );
  }

  const toEdit = (item) => {
    localStorage.setItem("draftProjectId", item?._id);
    setRoutes(true);
  };

  return (
    <>
      <section className="projectstable">
        <div className="table-responsive desktop_table">
          <table class="table">
            <thead>
              <tr>
                <th>
                  <div className="parent-tag" style={{ cursor: "pointer" }}>
                    Date Created
                    <div className="filter-btn">
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <th>
                  <h3>Created By</h3>
                </th>
                <th>
                  <h3>Project Name</h3>
                </th>
                <th>
                  <h3>Status</h3>
                </th>
                <th>
                  <h3>Rounds</h3>
                </th>
                <th>
                  <h3>Total Raised</h3>
                </th>
                <th>
                  <h3>No. Of Purchases</h3>
                </th>

                <th>
                  <h3 className="actiontable">Action</h3>
                </th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project) => (
                <tr key={project._id}>
                  <td>
                    <div className="twice-items">
                      <h6 className="datepara">
                        {formatDate(project.createdAt)}
                      </h6>
                      <p className="timepara">
                        {formatTime(project.createdAt)}
                      </p>
                    </div>
                  </td>
                  <td>
                    <h4>{project.createdBy || "N/A"}</h4>
                  </td>
                  <td>
                    <div className="newside">
                      <img
                        src={project.projectImage || "\\assets\\imgtable.svg"}
                        className="imginnerside"
                        alt="Project"
                      />
                      <h4>
                        {project.projectName || "N/A"}{" "}
                        <span>{project.projectTicker || "N/A"}</span>
                      </h4>
                    </div>
                  </td>
                  <td>
                    <h5 className="draftbutton">Draft</h5>
                  </td>
                  <td>
                    <h4>
                      {project.saleRounds?.length || 0}/
                      {project.saleRounds?.length > 0
                        ? project.saleRounds?.length
                        : "N/A"}
                    </h4>
                  </td>
                  <td>
                    <h4>-</h4>
                  </td>
                  <td>
                    <h4>-</h4>
                  </td>
                  <td>
                    <div onClick={() => toEdit(project)} className="svgarrrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M2.66666 8.66666L10.78 8.66666L7.05333 12.3933L7.99999 13.3333L13.3333 7.99999L8 2.66666L7.06 3.60666L10.78 7.33332L2.66666 7.33332L2.66666 8.66666Z"
                          fill="#02171D"
                        />
                      </svg>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="phonestable">
          {projects.map((project) => (
            <div key={project._id} className="tableeeenewphone">
              <div className="table_phooone">
                <div className="top_phone_tab">
                  <img
                    src={project.projectImage || "\\assets\\ronas.svg"}
                    alt="Project"
                  />
                  <p>{project.projectName || "N/A"}</p>
                  <h5>{project.projectTicker || "N/A"}</h5>
                  <button className="blue">Draft</button>
                </div>
                <div className="top_table">
                  <div>
                    <h2>Date Created </h2>
                    <div>
                      <p>
                        {formatDate(project.createdAt)}{" "}
                        <span>{formatTime(project.createdAt)}</span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <h2>Created By</h2>
                    <p>{project.createdBy || "N/A"}</p>
                  </div>
                </div>
                <div className="top_table">
                  <div>
                    <h2>Rounds</h2>
                    <p>
                      {project.saleRounds?.length || 0}/
                      {project.totalRounds || "N/A"}
                    </p>
                  </div>
                  <div>
                    <h2>Total Raised</h2>
                    <p>-</p>
                  </div>
                </div>
                <div className="top_table bottomsidee">
                  <div>
                    <h2>No. Of Purchases</h2>
                    <p>-</p>
                  </div>
                  <div>
                    <h2>Contract Address</h2>
                    <div className="adddressdiv">
                      <p>{project.contractAddress || "N/A"}</p>
                      {project.contractAddress && (
                        <span
                          onClick={() => copyAddress(project.contractAddress)}
                          style={{ cursor: "pointer" }}
                        >
                          {!copied ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M11.8125 1.53125H4.8125C4.63845 1.53125 4.47153 1.60039 4.34846 1.72346C4.22539 1.84653 4.15625 2.01345 4.15625 2.1875V4.15625H2.1875C2.01345 4.15625 1.84653 4.22539 1.72346 4.34846C1.60039 4.47153 1.53125 4.63845 1.53125 4.8125V11.8125C1.53125 11.9865 1.60039 12.1535 1.72346 12.2765C1.84653 12.3996 2.01345 12.4688 2.1875 12.4688H9.1875C9.36155 12.4688 9.52847 12.3996 9.65154 12.2765C9.77461 12.1535 9.84375 11.9865 9.84375 11.8125V9.84375H11.8125C11.9865 9.84375 12.1535 9.77461 12.2765 9.65154C12.3996 9.52847 12.4688 9.36155 12.4688 9.1875V2.1875C12.4688 2.01345 12.3996 1.84653 12.2765 1.72346C12.1535 1.60039 11.9865 1.53125 11.8125 1.53125ZM8.53125 11.1562H2.84375V5.46875H8.53125V11.1562ZM11.1562 8.53125H9.84375V4.8125C9.84375 4.63845 9.77461 4.47153 9.65154 4.34846C9.52847 4.22539 9.36155 4.15625 9.1875 4.15625H5.46875V2.84375H11.1562V8.53125Z"
                                fill="#329879"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M5.6 10.8L2.1 7.3L3.05 6.35L5.6 8.9L10.95 3.55L11.9 4.5L5.6 10.8Z"
                                fill="#329879"
                              />
                            </svg>
                          )}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <button className="detailbuton">
                  View Details{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M2.66671 8.66797L10.78 8.66797L7.05337 12.3946L8.00004 13.3346L13.3334 8.0013L8.00004 2.66797L7.06004 3.60797L10.78 7.33464L2.66671 7.33464L2.66671 8.66797Z"
                      fill="#02171D"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
        {projects?.length > 0 && (
          <div className="bottom_pagiation">
            <p>
              SHOWING {(pagination.currentPage - 1) * pagination.pageSize + 1}-
              {Math.min(
                pagination.currentPage * pagination.pageSize,
                pagination.totalCount
              )}{" "}
              OF {pagination.totalCount}
            </p>
            <div className="times_pagination">
              <svg
                onClick={() =>
                  pagination.currentPage > 1 &&
                  handlePageChange(pagination.currentPage - 1)
                }
                style={{
                  cursor:
                    pagination.currentPage > 1 ? "pointer" : "not-allowed",
                  opacity: pagination.currentPage > 1 ? 1 : 0.5,
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g opacity="0.5">
                  <path
                    d="M7.38904 1.93555L4.88763 1.93555L1.49459 7.99682L3.996 7.99682L7.38904 1.93555Z"
                    fill="#869397"
                  />
                  <path
                    d="M7.38904 14.0703L4.88763 14.0703L1.49459 8.00904L3.07108 6.96117L3.996 8.00904L7.38904 14.0703Z"
                    fill="#869397"
                  />
                  <path
                    d="M7.51655 6.85742H14.4616L13.1869 9.14313H6.24182L7.51655 6.85742Z"
                    fill="#869397"
                  />
                </g>
              </svg>
              <div className="numbers_inner">
                {Array.from(
                  { length: pagination.totalPages },
                  (_, i) => i + 1
                ).map((page) => (
                  <h2
                    key={page}
                    onClick={() => handlePageChange(page)}
                    style={{
                      cursor: "pointer",
                      fontWeight:
                        pagination.currentPage === page ? "bold" : "normal",
                      color:
                        pagination.currentPage === page ? "#329879" : "#869397",
                    }}
                  >
                    {page}
                  </h2>
                ))}
              </div>
              <svg
                onClick={() =>
                  pagination.currentPage < pagination.totalPages &&
                  handlePageChange(pagination.currentPage + 1)
                }
                style={{
                  cursor:
                    pagination.currentPage < pagination.totalPages
                      ? "pointer"
                      : "not-allowed",
                  opacity:
                    pagination.currentPage < pagination.totalPages ? 1 : 0.5,
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g opacity="0.5">
                  <path
                    d="M8.61098 14.0644L11.1124 14.0644L14.5054 8.00317L12.004 8.00317L8.61098 14.0644Z"
                    fill="#869397"
                  />
                  <path
                    d="M8.61098 1.92968L11.1124 1.92968L14.5054 7.99095L12.9289 9.03882L12.004 7.99095L8.61098 1.92968Z"
                    fill="#869397"
                  />
                  <path
                    d="M8.48351 9.14257H1.53846L2.81319 6.85686H9.75824L8.48351 9.14257Z"
                    fill="#869397"
                  />
                </g>
              </svg>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Draftprojectstables;
